import { Component, Input } from '@angular/core';

@Component({
  selector: 'heading-with-line',
  template: `
    <h4 *ngIf="size === 'h4'">{{ text }}</h4>
    <h3 *ngIf="size === 'h3'">{{ text }}</h3>
    <div class="divider"></div>
  `,
  styles: ['h4 { margin-bottom: 4px; margin-top: 24px;}'],
  standalone: false,
})
export class HeadingWithLine {
  @Input() size: 'h3' | 'h4' = 'h4';
  @Input() text: string;
}
